import { priceFromCost, clampParam } from "@acc/shared"
import { PriceType } from "../../../app/reducers/settingsReducer"

/**
 * Калькулятор цены WB — вариант default2 (фронт).
 *
 * Делегирует математику движку priceFromCost из @acc/shared.
 * Конфиг комиссий: nalogInKassa=true (NALOG применяется к KASSA),
 * denominatorFees=[KOEF], additives=[LOGISTIC].
 *
 * Математически даёт другой результат, чем default1 — налог применяется к разной базе.
 */
export const defaultCalcPrice2 = (
  props: PriceType & {
    price?: number
  },
): { price: number; old_price: number } => {
  const {
    sale = 0,
    price = 0,
    margin = 0,
    profit = 0,
    logistic = 0,
    ff = 0,
    coef = 0,
    tax = 0,
  } = props
  const currentPrice = priceFromCost(
    {
      price,
      margin: clampParam(margin, 0),
      minProfit: clampParam(profit, 0),
      ff: clampParam(ff, 0),
      nalog: clampParam(tax, 0),
      sale: Math.max(sale, 0) / 100,
      withSale: false,
    },
    {
      nalogInKassa: true,
      denominatorFees: [clampParam(coef, 0)],
      additives: [clampParam(logistic, 0)],
    },
  )
  const SALE = Math.max(sale, 0) / 100
  return {
    price: currentPrice,
    old_price: Math.ceil(currentPrice / (1 - SALE)),
  }
}
